<template>
<div class="text-center mt-5">
    <h3 class="all"> About Us</h3>
    <p class="lorium">Lorium ipsum dolor sit amet</p>
</div>  
</template>

<script>

export default {
 
  data() {
    return {};
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/page6/text.vue